module.exports = __webpack_public_path__ + "static/img/1033.5a431df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1033.jpg
// module id = 215
// module chunks = 0